import type {
  ApplicationConfig,
  VbenAdminProAppConfigRaw,
} from '@vben/types/global';

/**
 * 由 vite-inject-app-config 注入的全局配置
 */
function getBaseUrl(VITE_GLOB_API_URL:string):string{
  let res = ''
  let href = window.location.href
  let env = import.meta.env.VITE_ARMS_ENV
  if(env === 'prod' || env === 'pre'){
    if(href.indexOf('fengqian.cc') > -1){
      res = VITE_GLOB_API_URL
    }else if(href.indexOf('sufengerp.com') > -1){
      let startStr = env === 'pre' ? 'pre-' : ''
      res = `https://${startStr}api.sufengerp.com/`
    }else{
      res = VITE_GLOB_API_URL
    }
  }else{
    res = VITE_GLOB_API_URL
  }
  return res
}
export function useAppConfig(
  env: Record<string, any>,
  isProduction: boolean,
): ApplicationConfig {
  // 生产环境下，直接使用 window._VBEN_ADMIN_PRO_APP_CONF_ 全局变量
  const config = isProduction
    ? window._VBEN_ADMIN_PRO_APP_CONF_
    : (env as VbenAdminProAppConfigRaw);

  const { VITE_GLOB_API_URL } = config;
  let baseUrl = getBaseUrl(VITE_GLOB_API_URL)
  return {
    apiURL: baseUrl,
  };
}
